/**
 * CATMATIK — tracker d'événements.
 * Autonome, sans dépendance. Configuré par window.CMK (injecté dans theme.liquid).
 */
(function () {
  'use strict';

  var CFG = window.CMK || {};
  if (!CFG.endpoint) return;

  var SESSION_MAX_IDLE = 30 * 60 * 1000;   // 30 min
  var ATTRIB_TTL       = 90 * 24 * 3600e3; // 90 j — fenêtre d'attribution Google Ads
  var FLUSH_MS         = 3000;

  /* ── stockage tolérant (navigation privée, cookies bloqués) ── */
  function ls(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, val); return val;
    } catch (e) { return null; }
  }
  function ss(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val); return val;
    } catch (e) { return null; }
  }
  function uid() {
    try { return crypto.randomUUID(); }
    catch (e) { return 'x' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  }

  /* ── identité ── */
  var visitorId = ls('cmk_vid') || ls('cmk_vid', uid()) || uid();

  var lastSeen = +(ss('cmk_seen') || 0);
  var sessionId = ss('cmk_sid');
  if (!sessionId || Date.now() - lastSeen > SESSION_MAX_IDLE) sessionId = ss('cmk_sid', uid()) || uid();
  ss('cmk_seen', Date.now());

  /* ── attribution : capturée à l'arrivée, conservée 90 jours ── */
  var params = new URLSearchParams(location.search);
  var attrib;
  try { attrib = JSON.parse(ls('cmk_attrib') || 'null'); } catch (e) { attrib = null; }

  var incomingGclid = params.get('gclid') || params.get('wbraid') || params.get('gbraid');
  var incomingUtm = params.get('utm_source');
  var expired = !attrib || Date.now() - (attrib.t || 0) > ATTRIB_TTL;

  // Un nouveau clic payant écrase toujours l'attribution précédente (last non-direct click).
  if (incomingGclid || incomingUtm || expired) {
    attrib = {
      t: Date.now(),
      gclid: incomingGclid || (expired ? null : attrib && attrib.gclid) || null,
      utm_source: params.get('utm_source') || (expired ? null : attrib && attrib.utm_source) || null,
      utm_medium: params.get('utm_medium') || (expired ? null : attrib && attrib.utm_medium) || null,
      utm_campaign: params.get('utm_campaign') || (expired ? null : attrib && attrib.utm_campaign) || null,
      // Le mot-clé et le groupe d'annonces : ce qui dit quelle requête rapporte.
      utm_term: params.get('utm_term') || (expired ? null : attrib && attrib.utm_term) || null,
      utm_content: params.get('utm_content') || (expired ? null : attrib && attrib.utm_content) || null,
      landing_page: location.pathname + location.search,
      referrer: document.referrer && document.referrer.indexOf(location.host) === -1 ? document.referrer : null,
    };
    ls('cmk_attrib', JSON.stringify(attrib));
  }

  // Figé pour la durée de la session : un redimensionnement de fenêtre ne doit pas
  // faire basculer une même session de « desktop » à « mobile » dans les stats.
  var deviceType = ss('cmk_dev');
  if (!deviceType) {
    var w0 = window.innerWidth;
    deviceType = ss('cmk_dev', w0 < 768 ? 'mobile' : w0 < 1024 ? 'tablet' : 'desktop') ||
                 (w0 < 768 ? 'mobile' : w0 < 1024 ? 'tablet' : 'desktop');
  }
  function device() { return deviceType; }

  /* ── file d'attente ── */
  var queue = [];
  var timer = null;

  function flush(sync) {
    if (!queue.length) return;
    var payload = JSON.stringify(queue.splice(0, 50));
    clearTimeout(timer); timer = null;

    // sendBeacon survit à la fermeture de l'onglet ; fetch sert au cas où il est indisponible.
    var sent = false;
    if (sync && navigator.sendBeacon) {
      try { sent = navigator.sendBeacon(CFG.endpoint, new Blob([payload], { type: 'text/plain' })); } catch (e) {}
    }
    if (!sent) {
      try {
        fetch(CFG.endpoint, {
          method: 'POST', body: payload, keepalive: true,
          headers: { 'Content-Type': 'text/plain' },
        }).catch(function () {});
      } catch (e) {}
    }
  }

  function track(name, props) {
    var e = props || {};
    e.name = name;
    e.client_ts = Date.now();
    e.visitor_id = visitorId;
    e.session_id = sessionId;
    e.path = location.pathname;
    e.device = device();
    e.template = CFG.template || null;
    if (e.product_id === undefined && CFG.productId) e.product_id = CFG.productId;
    if (e.label === undefined && CFG.productTitle && e.product_id) e.label = CFG.productTitle;
    e.gclid = attrib.gclid;
    e.utm_source = attrib.utm_source;
    e.utm_medium = attrib.utm_medium;
    e.utm_campaign = attrib.utm_campaign;
    e.utm_term = attrib.utm_term;
    e.utm_content = attrib.utm_content;
    e.referrer = attrib.referrer;
    e.landing_page = attrib.landing_page;

    queue.push(e);
    ss('cmk_seen', Date.now());
    if (!timer) timer = setTimeout(function () { flush(false); }, FLUSH_MS);
  }
  window.cmkTrack = track;

  /* ── le gclid doit voyager jusqu'à la commande Shopify ── */
  var attribPushed = false;
  function pushAttribToCart() {
    if (attribPushed || (!attrib.gclid && !attrib.utm_source)) return;
    attribPushed = true;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            gclid: attrib.gclid || '',
            utm_source: attrib.utm_source || '',
            utm_campaign: attrib.utm_campaign || '',
            cmk_visitor: visitorId,
            cmk_session: sessionId,
          },
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  /* ── vue de page ── */
  track('page_view');
  // On se fie à la présence du produit, pas au nom du gabarit : celui-ci porte un
  // suffixe sur les gabarits alternatifs (« product.capsule »).
  if (CFG.productId) {
    track('product_view', { value: CFG.productPrice || null, currency: 'EUR' });
  }

  /* ── clics (délégation : robuste au contenu chargé après coup) ── */
  // Le thème a plusieurs gabarits produit avec des boutons différents
  // (.overlay-buy_button sur le gabarit standard, .offre__cta sur « capsule »).
  // On identifie donc le formulaire d'ajout, pas le bouton : ça vaut pour tous les gabarits.
  var CART_FORM = 'form[action*="/cart/add"]';
  var lastAtc = 0; // un clic sur le bouton déclenche aussi le submit : ne compter qu'une fois

  /** Seul un bouton qui soumet compte : type="button" ouvre un volet, il n'ajoute rien. */
  function submits(el) {
    var t = (el.getAttribute('type') || '').toLowerCase();
    return el.tagName === 'INPUT' ? t === 'submit' : (t === '' || t === 'submit');
  }

  /** Le bouton d'un formulaire peut vivre hors de celui-ci via l'attribut form="…". */
  function cartFormOf(el) {
    if (!el) return null;
    var inside = el.closest(CART_FORM);
    if (inside) return inside;
    var btn = el.closest('[form]');
    if (btn) {
      var f = document.getElementById(btn.getAttribute('form'));
      if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) return f;
    }
    return null;
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    // Menu de navigation mobile
    if (t.closest('a[href="#nav"], [aria-controls="nav"]')) {
      track('mobile_nav_open');
      return;
    }

    // Sélecteur d'offre. Testé avant l'ajout au panier : ces boutons sont À L'INTÉRIEUR
    // du formulaire d'ajout sans rien soumettre.
    // Deux thèmes coexistent : « offre__ » (thème publié) et « pas__ » (chantier CRO).
    if (t.closest('[data-offre-invite], .offre__invite, [data-pas-invite], .pas__invite')) {
      track('offre_open'); return;
    }
    if (t.closest('[data-offre-fermer], .offre__fermer, [data-pas-fermer], .pas__fermer')) {
      track('offre_close'); return;
    }
    if (t.closest('[data-pas-replie], .pas__replie')) { track('offre_replie'); return; }

    // Ajout au panier — le clic, pas encore l'ajout réussi.
    // .overlay-buy_button est ajouté en secours : sur capsule il référence un
    // formulaire absent de la page, donc cartFormOf() ne peut pas le rattacher.
    var btn = t.closest('button, input[type="submit"]');
    if (btn && submits(btn) &&
        (cartFormOf(btn) || btn.closest('.overlay-buy_button, .offre__cta, .pas__achat'))) {
      lastAtc = Date.now();
      track('add_to_cart_click', {
        variant_id: currentVariant(),
        label: (btn.textContent || '').trim().slice(0, 60) || null,
      });
      pushAttribToCart();
      return;
    }

    // Preuve sociale du gabarit capsule : un visiteur qui fouille les avis hésite.
    if (t.closest('[data-au-pack], .au__conseil-cta'))    { track('pack_cta'); return; }
    if (t.closest('[data-avis-more], .avis__more'))       { track('avis_voir_plus'); return; }
    if (t.closest('[data-avis-zoom], .avis__photo'))      { track('avis_photo_zoom'); return; }
    if (t.closest('[data-avis-lire], .avis__lire'))       { track('avis_lire_suite'); return; }

    // Ouverture d'une question FAQ = une objection identifiée.
    // Thème publié : <button aria-expanded>. Chantier CRO : <details><summary>.
    var faq = t.closest('.faq-luxury__question');
    if (faq) {
      if (faq.getAttribute('aria-expanded') !== 'true') {
        track('faq_open', { label: (faq.textContent || '').trim().slice(0, 200) });
      }
      return;
    }
    var sum = t.closest('summary.cmk-faq__sum, .cmk-faq__sum');
    if (sum) {
      // Au moment du clic, <details> n'a pas encore basculé : open=false = ouverture.
      var det = sum.closest('details');
      if (!det || !det.open) {
        track('faq_open', { label: (sum.textContent || '').trim().slice(0, 200) });
      }
      return;
    }

    // Vidéos clients : « ugc-video-card » (thème publié), « cmk-videos » (chantier CRO).
    var vid = t.closest('.ugc-video-card__play, .cmk-videos__item');
    if (vid) {
      track('ugc_video_play', { label: (vid.getAttribute('aria-label') || '').slice(0, 80) || null });
      return;
    }

    // Sections dépliantes du chantier CRO : elles portent les objections du produit.
    var dep = t.closest('.cmk-odeurs__btn, .cmk-entretien__btn');
    if (dep) {
      track('section_open', {
        label: (dep.textContent || '').trim().slice(0, 80) ||
               dep.className.split(' ')[0] || null,
      });
      return;
    }

    if (t.closest('a[href*="/cart"], .side-cart-trigger, [data-side-cart]')) { track('cart_open'); return; }

    if (t.closest('[name="checkout"], a[href*="/checkout"]')) { track('checkout_start'); pushAttribToCart(); return; }

    // Sélection de variante
    var sw = t.closest('[class*="swatch"], .product-form__input label, input[name^="option"]');
    if (sw) {
      track('variant_select', { label: (sw.getAttribute('title') || sw.textContent || '').trim().slice(0, 100) || null });
    }
  }, true);

  // Filet : un formulaire peut être soumis par la touche Entrée ou par du JS,
  // sans qu'aucun bouton n'ait été cliqué.
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.matches && f.matches(CART_FORM) && Date.now() - lastAtc > 1000) {
      lastAtc = Date.now();
      track('add_to_cart_click', { variant_id: currentVariant(), label: 'submit' });
      pushAttribToCart();
    }
  }, true);

  function currentVariant() {
    var i = document.querySelector(CART_FORM + ' [name="id"]:checked') ||
            document.querySelector(CART_FORM + ' [name="id"]');
    return i ? i.value : null;
  }

  /* ── ajout au panier confirmé : on écoute le réseau, pas le bouton ──
     L'écart entre add_to_cart_click et add_to_cart révèle les échecs silencieux. */
  /** Shopify renvoie l'article réellement ajouté : c'est lui qui fait foi, pas la page
      (un accessoire ajouté depuis une fiche litière serait sinon compté comme la litière). */
  function trackAdded(payload) {
    var items = payload && payload.items ? payload.items : [payload];
    var vu = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.product_id) continue;
      vu = true;
      track('add_to_cart', {
        product_id: String(it.product_id),
        variant_id: it.variant_id ? String(it.variant_id) : null,
        label: it.product_title || it.title || null,
        value: typeof it.price === 'number' ? it.price / 100 : null,
        currency: 'EUR',
        meta: JSON.stringify({ qte: it.quantity || 1, variante: it.variant_title || null }),
      });
    }
    if (!vu) track('add_to_cart', { variant_id: currentVariant() });
  }

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          // clone() : ne pas consommer le flux que le thème va lire lui aussi.
          r.clone().json().then(trackAdded).catch(function () {
            track('add_to_cart', { variant_id: currentVariant() });
          });
        }).catch(function () {});
      }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (String(url).indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        try { trackAdded(JSON.parse(this.responseText)); }
        catch (e) { track('add_to_cart', { variant_id: currentVariant() }); }
      });
    }
    return _open.apply(this, arguments);
  };

  /* ── profondeur de lecture ── */
  var marks = [25, 50, 75, 100], hit = {};
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    var p = ((window.scrollY || window.pageYOffset) / h) * 100;
    for (var i = 0; i < marks.length; i++) {
      if (p >= marks[i] && !hit[marks[i]]) {
        hit[marks[i]] = 1;
        track('scroll_depth', { value: marks[i] });
      }
    }
  }
  var scrollTimer;
  window.addEventListener('scroll', function () {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; onScroll(); }, 300);
  }, { passive: true });

  /* ── clics de rage : 3 clics au même endroit en moins d'une seconde ── */
  var recent = [];
  document.addEventListener('click', function (ev) {
    var now = Date.now();
    recent = recent.filter(function (c) { return now - c.t < 1000; });
    recent.push({ t: now, x: ev.clientX, y: ev.clientY });
    if (recent.length >= 3) {
      var near = recent.every(function (c) {
        return Math.abs(c.x - recent[0].x) < 40 && Math.abs(c.y - recent[0].y) < 40;
      });
      if (near) {
        recent = [];
        var el = ev.target.closest ? ev.target.closest('button, a, [role="button"], div') : null;
        track('rage_click', {
          label: el ? ((el.className && String(el.className).slice(0, 60)) || el.tagName) : null,
        });
      }
    }
  }, true);

  /* ── temps passé ── */
  var arrived = Date.now(), firstClick = null;
  document.addEventListener('click', function () {
    if (firstClick === null) {
      firstClick = Date.now() - arrived;
      track('first_click', { value: Math.round(firstClick / 1000) });
    }
  }, { once: true, capture: true });

  function leave() {
    track('page_leave', { value: Math.round((Date.now() - arrived) / 1000) });
    flush(true);
  }
  window.addEventListener('pagehide', leave);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush(true);
  });
})();
